import { render, staticRenderFns } from "./mutable-list.component.vue?vue&type=template&id=079b972d&scoped=true"
import script from "./mutable-list.component.vue?vue&type=script&lang=ts"
export * from "./mutable-list.component.vue?vue&type=script&lang=ts"
import style0 from "./mutable-list.component.vue?vue&type=style&index=0&id=079b972d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079b972d",
  null
  
)

export default component.exports